// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__RE8MT","inner":"Footer_inner__2TZDl","nextIcon":"Footer_nextIcon__43LOh","innerLeft":"Footer_innerLeft__UI_hT"};